<template>
    <div>
        <div class="flex flex-wrap items-center justify-between text-left text-lg text-white">
            <div>{{ label }}</div>
            <slot name="tooltip"></slot>
        </div>
        <select
            :name="name"
            :value="modelValue"
            class="w-full rounded-sm border border-gray-400 bg-gray-600 p-3 text-white"
            @input="$emit('update:modelValue', $event.target.value)"
        >
            <template v-if="showEmptyValue">
                <option value="">-</option>
            </template>
            <template
                v-for="value in sortedOptionEntries"
                :key="value[0]"
            >
                <option :value="value[0]">
                    {{ value[1] }}
                </option>
            </template>
        </select>
    </div>
</template>

<script>
export default {
    name: 'FeConfiguratorDropdown',
    props: {
        name: { type: String, required: true },
        modelValue: { type: [String, Number], default: null },
        label: { type: String, required: true },
        options: { type: Object, required: true },
        showEmptyValue: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
    computed: {
        sortedOptionEntries() {
            return Object.entries(this.options).sort(([, a], [, b]) => parseInt(a) - parseInt(b));
        },
    },
};
</script>
